import { InjectionToken } from '@angular/core';
import { HttpHeaders, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { User } from '~auth/model';


export interface RequestOptions {
  headers?: HttpHeaders;
  observe?: 'body';
  params?: HttpParams;
  reportProgress?: boolean;
  responseType?: any;
  withCredentials?: boolean;
}

export interface AuthConfig {
  redirectUrl?: string;
  token?: string;
  cookie?: string;
  aoUrl?: string;
  baseUrl?: string;
  paymentGatewayUrl?: string;
  useCookie?: boolean;
  interceptor?: any;
}

export interface Authenticator {
  signIn?(username: string, password: string): Observable<User>;
  signOut(): Observable<boolean>;
}

export const AO_AUTH_URL: InjectionToken<string> = new InjectionToken<string>('AO_AUTH_URL');
export const AUTH_PROVIDERS = new InjectionToken<AuthProvider[]>('AUTH_PROVIDERS');
export const REDIRECT_URL = new InjectionToken<string>('REDIRECT_URL');
export const SSO_TOKEN_NAME: InjectionToken<string> = new InjectionToken<string>('SSO_TOKEN_NAME');
export const SSO_COOKIE_NAME: InjectionToken<string> = new InjectionToken<string>('SSO_COOKIE_NAME');
export const USE_COOKIE: InjectionToken<boolean> = new InjectionToken<boolean>('USE_COOKIE');
export const BASE_URL: InjectionToken<string> = new InjectionToken<string>('BASE_URL');
export const PAYMENT_GATEWAY_URL: InjectionToken<string> = new InjectionToken<string>('PAYMENT_GATEWAY_URL');

export abstract class AuthProvider implements Authenticator {
  PING_TIMER?: number;

  abstract isAuthenticated(): boolean;

  abstract ping?(): Observable<boolean>;
  abstract refresh?(local?: boolean): Observable<User>;
  abstract getToken?(): any;

  abstract signIn?(username: string, password: string): Observable<User>;
  abstract signOut(): Observable<boolean>;

  abstract intercept(request: HttpRequest<any>): HttpRequest<any>;
}




// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/providers/auth.provider.ts